module.exports = __webpack_public_path__ + "static/img/foot_code2.e1c50849.png";